// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## ProductCategory Get
/**
 *
 * @param {{params: object, query: { search: string, companyId: string, productBrandId?: string, page: number, limit: number  }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const version = localStorage.getItem("version");
  // for v1
  if (version === "v1") option.query.parasutAccountId = option.query.companyId;
  const response = await $api.get(Endpoints.ProductCategory.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## ProductCategory Create
/**
 *
 * @param {{"name": "string","code": "string"}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.ProductCategory.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProductCategory Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.ProductCategory.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProductCategory Update
/**
 *
 * @param {{"name": "string","code": "string", isActive: boolean}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.ProductCategory.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProductCategory Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.ProductCategory.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProductCategory SortByOrder
/**
 *
 * @param {Array<{id: string, order: number}>} form
 *
 * @returns
 */
export const SortByOrder = async (form) => {
  const response = await $api.post(
    Endpoints.ProductCategory.SortByOrder(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  SortByOrder,
};
